<template>
	<div>
			<p class="medium-h-text bold-text black-text mb-0 pl-4">
						{{header.toUpperCase()}}
				</p>
				<ul class="list-sect mb-0 py-4 pl-4">
					<li v-for="(item, index) in items" :key="index">
						<b-row>
							<b-col cols="5" md="4"><p class="p mb-1">{{item.date}}</p></b-col>
							<b-col cols="7" md="8"><p class="p bolden-text mb-1">{{item.content}}</p></b-col>
						</b-row>
					</li>
				</ul>
	</div>
</template>

<script>
export default {
	props:[
		"header", "items"
	]
}
</script>

<style>
.list-sect{
	border-top:1px solid  #71201c;
	border-bottom: 1px solid #71201c;
}
ul{
	list-style: none;
}
</style>